import React from 'react';
import PropTypes from 'prop-types';

import { withStyles } from 'material-ui/styles';
import Select from 'material-ui/Select';
import Table, { TableBody } from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import Paper from 'material-ui/Paper';
import Typhography from 'material-ui/Typography';
import RefreshIcon from 'material-ui-icons/Refresh';

import TableHead from './TableHead';
import ImpedanceModelingRow from './ImpedanceModelingRow';
import TableToolbar from '../../../../common/TableToolbar';
import { mhz2label, getLengthUnit } from '../../../../../lib/unitConversions'

import { impedanceModelingPropType } from '../propTypes';

const styles = theme => ({
  root: {
    marginTop: theme.spacing.unit * 3,
    width: '100%',
    overflowX: 'auto',
  },
  toolbar: {
    width: '100%',
    overflowX: 'hidden',
  },
  body: {
    width: '100%',
    overflowX: 'auto',
  },
  table: {
    minWidth: 700,
  },
  grow: {
    flexGrow: 1
  },
  toolbarContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center'
  }
})

export const ImpedanceModelingsTable = (props) => {
  const {
    availableMhzs,
    classes,
    displayMhz,
    impedanceModelings,
    onMhzUpdate,
    refresh,
    onSimulationModelClick,
    currentPath,
    lengthUnit,
    print
  } = props;
  const unit = getLengthUnit(lengthUnit);

  return (
    <Paper className={classes.root}>
      <Paper className={classes.toolbar}>
        <TableToolbar>
          <div className={classes.toolbarContainer}>
            <Typhography
              variant="title"
              color="inherit"
              className={classes.grow}
            >
              Impedance Modeling
              {availableMhzs.length > 0 ? (
                <span>
                  {' @ '}
                  {print
                   ? mhz2label(displayMhz)
                   : (
                     <Select native value={displayMhz} onChange={onMhzUpdate}>
                       {availableMhzs.map(mhz=>(
                         <option key={mhz} value={mhz}>{mhz2label(mhz)}</option>
                      ))}
                     </Select>
                   )}
                </span>
              ) : null}
            </Typhography>
            {!print && (
              <IconButton onClick={refresh}>
                <RefreshIcon />
              </IconButton>
            )}
          </div>
        </TableToolbar>
      </Paper>
      <Paper className={classes.body}>
        <Table className={classes.table}>
          <TableHead lengthUnitSymbol={unit.symbol} print={print} />
          <TableBody>
            {impedanceModelings ? impedanceModelings.map(impedanceModeling => (
              <ImpedanceModelingRow
                key={impedanceModeling.copperKey}
                impedanceModeling={impedanceModeling}
                lengthUnit={lengthUnit}
                onSimulationModelClick={onSimulationModelClick(impedanceModeling)}
                currentPath={currentPath}
                print={print}
              />
            )) : null}
          </TableBody>
        </Table>
      </Paper>
    </Paper>
  );
}

ImpedanceModelingsTable.propTypes = {
  classes:                PropTypes.objectOf(PropTypes.string).isRequired,
  availableMhzs:          PropTypes.arrayOf(PropTypes.number).isRequired,
  impedanceModelings:     PropTypes.arrayOf(impedanceModelingPropType).isRequired,
  displayMhz:             PropTypes.number,
  onMhzUpdate:            PropTypes.func.isRequired,
  refresh:                PropTypes.func.isRequired,
  onSimulationModelClick: PropTypes.func.isRequired,
  currentPath:            PropTypes.string,
  lengthUnit:             PropTypes.string.isRequired,
  print:                  PropTypes.bool,
}

ImpedanceModelingsTable.defaultProps = {
  displayMhz: undefined,
  currentPath: undefined,
  print: undefined,
}

export default  withStyles(styles)(ImpedanceModelingsTable);


// WEBPACK FOOTER //
// ./src/components/StackupDesign/Viewer/ResultViewer/ImpedanceModelingsTable/ImpedanceModelingsTable.js